// extracted by mini-css-extract-plugin
export default {"detailTable":"styles_detailTable__vS+XQ","select":"styles_select__vbTON"};